import { format, parseISO, differenceInYears } from 'date-fns';
import { es } from 'date-fns/locale';

const MONTHS_ES_SHORT = [
  'ene',
  'feb',
  'mar',
  'abr',
  'may',
  'jun',
  'jul',
  'ago',
  'sep',
  'oct',
  'nov',
  'dic',
];

const MONTHS_ES_LONG = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
];

/** "22 de abril de 2026" */
export function formatLongDateEs(d: Date | string): string {
  const date = typeof d === 'string' ? parseISO(d) : d;
  const m = MONTHS_ES_LONG[date.getMonth()] ?? '';
  return `${date.getDate()} de ${m} de ${date.getFullYear()}`;
}

/** "22 Abr 2026" */
export function formatShortDateEs(d: Date | string): string {
  const date = typeof d === 'string' ? parseISO(d) : d;
  const m = MONTHS_ES_SHORT[date.getMonth()] ?? '';
  const cap = m.charAt(0).toUpperCase() + m.slice(1);
  return `${String(date.getDate()).padStart(2, '0')} ${cap} ${date.getFullYear()}`;
}

/** "10:13 p. m." */
export function formatTimeEs(d: Date): string {
  let h = d.getHours();
  const m = String(d.getMinutes()).padStart(2, '0');
  const ampm = h >= 12 ? 'p. m.' : 'a. m.';
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${m} ${ampm}`;
}

/** Edad en años cumplidos a partir de fecha de nacimiento ISO. */
export function ageFromBirthdate(iso: string): number {
  return differenceInYears(new Date(), parseISO(iso));
}

/** Iniciales en mayúscula a partir de nombre/apellido. */
export function initials(nombres: string, apellidos: string): string {
  const a = nombres.trim().charAt(0).toUpperCase();
  const b = apellidos.trim().charAt(0).toUpperCase();
  return `${a}${b}`;
}

/** Fecha relativa simple "21 de abril" (sin año). */
export function formatDayMonthEs(d: Date | string): string {
  const date = typeof d === 'string' ? parseISO(d) : d;
  return format(date, "d 'de' MMMM", { locale: es });
}
